import { useState, useRef, useEffect } from "react";

export default function RefreshButton() {
  const [refreshing, setRefreshing] = useState(false);
  // 2026-07-17 timer-leak fix (Roster 3fa233fc class): the 2500ms un-disable timer
  // held no id — its setRefreshing tail survived unmount (setState on a dead
  // component; fires into a torn-down jsdom env on a slow CI worker → uncaught
  // ReferenceError). Tracked ref + clearTimeout on re-arm and on unmount.
  const resetTimerRef = useRef(null);
  const handleClick = () => {
    setRefreshing(true);
    window.dispatchEvent(new CustomEvent('blitz-refresh'));
    clearTimeout(resetTimerRef.current);
    resetTimerRef.current = setTimeout(() => setRefreshing(false), 2500);
  };
  useEffect(() => () => clearTimeout(resetTimerRef.current), []);
  return (
    <button onClick={handleClick} disabled={refreshing} title="Refresh all data from server" aria-label="Refresh all data from server"
      style={{ display:"flex", alignItems:"center", background: refreshing ? "rgba(16,185,129,0.25)" : "rgba(16,185,129,0.12)", border:"1.5px solid rgba(16,185,129,0.35)", color:"#10B981", cursor: refreshing ? "not-allowed" : "pointer", fontSize:16, fontWeight:700, padding:"6px 8px", borderRadius:8, transition:"all 0.2s", opacity: refreshing ? 0.8 : 1 }}
      onMouseEnter={e=>{if(!refreshing)e.currentTarget.style.background="rgba(16,185,129,0.25)";}}
      onMouseLeave={e=>{if(!refreshing)e.currentTarget.style.background="rgba(16,185,129,0.12)"}}
    >{refreshing ? <span style={{display:"inline-block",animation:"spin 0.7s linear infinite"}}>🔄</span> : "🔄"}</button>
  );
}
